<template>
  <div class="groupShopListPage">
      <mu-appbar class="head">
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>        
        <p class="title">拼团</p>
        <mu-icon-menu icon=":fa fa-more" slot="right">
          <mu-menu-item to="/usercenter/index" title="个人中心"/>
          <mu-menu-item to="/" title="首页"/>
          <mu-menu-item to="/retail/cart" title="购物车"/>
          <!-- <mu-menu-item to="/usercenter/pintuanOrderList" title="拼团订单"/> -->
        </mu-icon-menu>
      </mu-appbar>
      <mu-list>
        <template v-for="activityItem in activityList">
          <div class="list_item" v-if="activityItem.Flist" :key="activityItem.Fid">
              <div class="itemTop">
                <router-link :to="'/groupShop/groupProductList?id='+activityItem.Fid">
                  <div class="itemTitle">
                    <p class="activeName">{{activityItem.Fname}}</p> 
                    <p class="time">距离结束 <span>{{activityItem.FremainingTime}}</span> </p>
                  </div>
                </router-link>
                <div class="topRight" v-if="activityItem.FcountJoinGroup>0">
                  <p class="peopleCount">{{activityItem.FcountJoinGroup}}人正在拼</p>
                  <mu-avatar :src="headItem" class="zindexOne" slot="leftAvatar" v-for="(headItem,index) in activityItem.FUserHeadList" :key="index" />                 
                </div>
              </div>
              <div class="product" v-if="activityItem.Flist">
                <mu-list-item class="product_item" v-for="proItem in activityItem.Flist" :key="proItem.Fid">                   
                  <img v-if="proItem.ImagePath!=null" :src="proItem.ImagePath" class="proImg" alt=""> 
                  <img v-else src="/static/productMoren.png" class="proImg" alt=""> 
                  <div class="product_info" :style="{width: proItemInfoWidth +'px'}">
                      <div class="product_title">
                          <span class="slaePrice">{{proItem.ZheKou}}折</span>
                          <span class="prime_cost">指导价{{proItem.OldPrice}}元</span>
                          {{proItem.ProductName}}
                      </div>
                      <div class="sign">
                        <div class="shopNum sign">{{activityItem.FgroupNumber}}人团</div>
                        <div class="free_post sign" v-if="!proItem.IsFreight">包邮</div>
                      </div> 
                      <div class="price_time">
                          <p class="price">拼团价<span>{{proItem.FminSkuPrice}}</span>元</p>
                          <p class="sellCount">已团{{proItem.FcountJoinGroup}}件</p>
                      </div>
                      <router-link :to="'/retail/productDetail?skuId='+proItem.FminSkuId+'&activityId='+activityItem.Fid">
                        <div class="num_goshop">         
                            <mu-raised-button label="去拼团" class="demo-raised-button"/>                                 
                        </div>
                      </router-link>  
                  </div>
                </mu-list-item>
              </div>
                <div style="text-align:center; font-size:12px;color: #999;">
                  <router-link :to="'/groupShop/groupProductList?id='+activityItem.Fid">
                  查看更多
                </router-link>
                  </div>
          </div>
        </template>
      </mu-list>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>
<script>
import siteconfig from '../../util/siteconfigCache'
export default {
  data() {
    return {
       proItemInfoWidth: (parseInt(document.documentElement.clientWidth)-137),
       loaded:false,
       activityList:[],
    }
  },
  mounted() {
    this.GetActivityList()
    
  },
  methods: {  
    GoHistory(){
      this.$router.goBack()
    },

    GetActivityList(){
      var ths = this;   
      ths.$refs.XRtoast.load('加载中...',false)
      ths.$post(
        "/Shop/PinTuanServer/WapActivityGetList"
      ).then(function(res) {
        ths.loaded= false
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          ths.activityList = {}
          //ths.$refs.XRtoast.failed(res.Msg, true)
        }
        else{      
          ths.activityList = res.Data
          ths.loaded= false
        }
      });

    }
  }
};
</script>
<style>
  .groupShopListPage{

  }
  .groupShopListPage .head p.title{
    text-align: center;
    font-size: 16px;
  }
  .groupShopListPage .mu-list{
    padding: 0;
  }
  .groupShopListPage .mu-list .list_item:first-child{
    margin: 0;
  }
  .groupShopListPage .mu-list .list_item{
    margin-top: 22px;
    background: #fff;
    padding: 15px 0;
  }
  .groupShopListPage .mu-list .list_item .itemTop{
    overflow: hidden;
    padding: 0 16px;
  }
  .groupShopListPage .mu-list .list_item .itemTop .itemTitle{
    float: left;
    font-size: 16px;
    width: 40%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 50px;
  }
  .groupShopListPage .mu-list .list_item .itemTop .itemTitle .activeName{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
    color:#2c3e50;
  }
  .groupShopListPage .mu-list .list_item .itemTop .itemTitle .time{
    font-size: 12px;
    color: #999;
  }
  .groupShopListPage .mu-list .list_item .itemTop .itemTitle .time span{
    padding-left: 5px;
    color: #DEAAA7;
  }
  .groupShopListPage .mu-list .list_item .itemTop .topRight{
    float: right;
    display: flex;
    align-items: center;
    background: #FEF2F9;
    width: auto;
    padding: 0 5px;
    border-radius: 15px;
    position: relative;
    height: 30px;
    padding-right: 60px;
    margin-top: 5px;
  }
  .groupShopListPage .mu-list .list_item .itemTop .topRight .peopleCount{
    font-size: 14px;
    color: red;
    padding-right: 5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .groupShopListPage .mu-list .list_item .itemTop .topRight .mu-avatar{
    width: 23px;
    height: 23px;
    position: absolute;
    background: #fff;
    border-radius: 50%; 
    top: 3.5px;
  }
  .groupShopListPage .mu-list .list_item .itemTop .topRight .zindexOne:nth-child(2){
    right: 35px;
  }
   .groupShopListPage .mu-list .list_item .itemTop .topRight .zindexOne:nth-child(3){
    right: 20px;
  }
  .groupShopListPage .mu-list .list_item .itemTop .topRight .zindexOne:nth-child(4){
    right: 5px;
  }
  .groupShopListPage .mu-list .list_item .product .product_item .proImg{
    width: 95px;
    float: left;
    background: white;
    height: 95px;
  }
  .groupShopListPage .mu-list .list_item .product .product_item .product_info{
    float: right;
    margin-left: 10px;
  }
  .groupShopListPage .mu-list .list_item .product .product_item .product_info .product_title{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 14px;
    color: #000;
  }
  .groupShopListPage .mu-list .list_item .product .product_item .product_info .product_title .slaePrice{
    color: red;
    font-weight: bold;
  }
  .groupShopListPage .mu-list .list_item .product .product_item .product_info .product_title .prime_cost{
    color: #666;
  }
  .groupShopListPage .mu-list .list_item .product .product_item .product_info .sign{
    text-align: center;
    border-radius: 2px;
    color: #fff;
    font-size: 12px;
    padding: 1px 0;
    overflow: hidden;
  }
  .groupShopListPage .mu-list .list_item .product .product_item .product_info .sign .shopNum{
    background: #EB4D54;
    width: 40px;
    border-radius: 5px;
    margin-right: 10px;
    float: left;
  }
  .groupShopListPage .mu-list .list_item .product .product_item .product_info .sign .free_post{
    float: left;
    width: 30px;
    border-radius: 5px;
    margin-right: 10px;
    background: #CC9137;
  }
  .groupShopListPage .mu-list .list_item .product .product_item .product_info .price_time{
    float: left;
  }
  .groupShopListPage .mu-list .list_item .product .product_item .product_info .num_goshop{
    float: right;
  }
  .groupShopListPage .mu-list .list_item .product .product_item .product_info .price_time .price{
    color: #C13B38;
    font-size: 14px;
    line-height: 20px;
    height: 20px;
    margin-top: 11px;
  }
  .groupShopListPage .mu-list .list_item .product .product_item .product_info .price_time .price span{
    font-size: 20px;
    padding: 0 5px;
  }
  .groupShopListPage .mu-list .list_item .product .product_item .product_info .price_time .sellCount{
    font-size: 12px;
    color: #999;
    text-align: left;
  }
  .groupShopListPage .mu-list .list_item .product .product_item .product_info .num_goshop .mu-raised-button{
    min-width: 60px;
    height: 25px;
    margin-top: 13px;
    background: #C13B38;
    color: #fff;
  }
  .groupShopListPage .mu-list .list_item .mu-item{
    padding: 11px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/groupShop/groupShopList.vue